// Move buttons in header for screens bigger han 1100
(function () {
    var buttons = document.querySelector('.o-header__buttons');
    var headerMiddle = document.querySelector('.o-header__middle');
    if (!buttons || !headerMiddle) return;

    function moveButtons() {
        if (window.innerWidth > 1250) {
            var replaceNav = headerMiddle.querySelector('.o-header__nav.replace-megamenu');
            if (replaceNav) {
                // Insert after replaceNav
                var next = replaceNav.nextElementSibling;
                // If next is the buttons element already, do nothing
                if (next !== buttons) {
                    if (next) {
                        headerMiddle.insertBefore(buttons, next);
                    } else {
                        headerMiddle.appendChild(buttons);
                    }
                }
            } else {
                // Fallback: append to header middle
                if (buttons.parentElement !== headerMiddle) headerMiddle.appendChild(buttons);
            }
        }
        // If viewport <= 1100px we don't move it back (preserve original markup) —
        // If you want it to move back, I can store original parent and restore on resize.
    }

    // Run immediately and on resize (debounced)
    moveButtons();
    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(moveButtons, 150);
    });
})();